import React from 'react';
import {
  TextFields as TextFieldsIcon,
  Notes as NotesIcon,
  Numbers as NumbersIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  CalendarToday as CalendarTodayIcon,
  AccessTime as AccessTimeIcon,
  Event as EventIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Link as LinkIcon,
  ArrowDropDownCircle as ArrowDropDownCircleIcon,
  Checklist as ChecklistIcon,
} from '@mui/icons-material';
import { ColumnConfigItem, CustomColumnDefinition, CustomColumnType } from '../../../types/lead';

export interface ManageLeadColumnsDialogProps {
  open: boolean;
  onClose: () => void;
  resolvedColumns: ColumnConfigItem[];
  customColumns: CustomColumnDefinition[];
  onSaveTableConfig: (updated: ColumnConfigItem[]) => Promise<any>;
  onCreateCustomColumn: (name: string, type: CustomColumnType, options?: string[]) => Promise<any>;
  onPatchCustomColumn: (key: string, patchPayload: { name?: string; options?: string[] }) => Promise<any>;
  onDeactivateCustomColumn: (key: string) => Promise<any>;
  initialTab?: number;
}

export interface ColumnTypeConfig {
  type: CustomColumnType;
  label: string;
  description: string;
  icon: React.ElementType;
}

// Allowed Custom Column Types
export const CUSTOM_COLUMN_TYPES: ColumnTypeConfig[] = [
  { type: 'text', label: 'Text', description: 'Short single-line text', icon: TextFieldsIcon },
  { type: 'textarea', label: 'Paragraph', description: 'Multi-line text or notes', icon: NotesIcon },
  { type: 'number', label: 'Number', description: 'Numeric values or counts', icon: NumbersIcon },
  { type: 'boolean', label: 'Yes / No', description: 'Choose Yes or No', icon: CheckCircleOutlineIcon },
  { type: 'date', label: 'Date', description: 'Calendar date', icon: CalendarTodayIcon },
  { type: 'time', label: 'Time', description: 'Time of day', icon: AccessTimeIcon },
  { type: 'datetime', label: 'Date & Time', description: 'Date and time', icon: EventIcon },
  { type: 'email', label: 'Email', description: 'Email address', icon: EmailIcon },
  { type: 'phone', label: 'Phone', description: 'Phone number', icon: PhoneIcon },
  { type: 'url', label: 'Link', description: 'Web link or URL', icon: LinkIcon },
  { type: 'select', label: 'Dropdown', description: 'Pick one option from a list', icon: ArrowDropDownCircleIcon },
  { type: 'multi_select', label: 'Multiple Choice', description: 'Pick one or more options from a list', icon: ChecklistIcon },
];
